module.exports = __webpack_public_path__ + "2b912f7c0653008ca28ebacda49025e7.gif";